<a class="btn btn-white mw-btn" href="javascript:window.history.back();">
  <i class="bi bi-chevron-left me-1"></i>
  <span class="">{{ 'Global.btn_Back' | translate }}</span>
</a>
